import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import { REST_API_URL, APP_PATH, PERMISSION_READ, PERMISSION_DELETE, PERMISSION_UPDATE } from "../../../Utils/Global";

import PermissionCheck from '../../Permissions/PermissionCheck';

import Geom from '../../Entity/Geom';

/**
* Class Action
* Generic component to generate row actions
**/
class Action extends Component {
  /**
  * props
  * mode : readonly/add/edit
  * parentGrid : parent container (Grid)
  * objectClass : class name of the object's form
  * object : instance data
  * fields : displayable field list
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
		super(props);

    this.state = {
      mode: props.mode
    };

    // Bind event functions to keep scope
    this.deleteObject = this.deleteObject.bind(this);
	}

  /**
  * componentWillReceiveProps
  * Update state if needed
  **/
  componentWillReceiveProps(nextProps) {
    if(this.props.mode !== nextProps.mode) {
      let state = this.state;
      state.mode = nextProps.mode;
      this.setState(state);
    }
  }

  /**
  * render
  * Rendering component function : display the row
  **/
  render() {
    const keyField = this.props.parentGrid.getRowKey();

    const deleteButton = <span className="grid-action glyphicon glyphicon-remove" onClick={this.deleteObject} />;

    let editButton = null;
    if(this.props.isGeom !== true) {
      if(this.props.parentModal) {
        editButton = <span onClick={this.editObjectForm.bind(this)} className="grid-action glyphicon glyphicon-edit"></span>;
      } else {
        editButton =
          <Link to={APP_PATH + "/" + this.props.parentGrid.props.path + "/" + this.props.object[keyField] + "/edit"}>
            <span className="grid-action glyphicon glyphicon-edit" />
          </Link>;
      }
    } else {
      editButton =
        <span className="grid-action glyphicon glyphicon-edit" onClick={this.openGeomModal.bind(this)} >
          <Geom ref="geomModal" object={this.props.object} path={REST_API_URL + this.props.parentGrid.props.path + "/"} parentGrid={this.props.parentGrid} />
        </span>;
    }

    const viewButton = (this.props.parentModal) ?
      <span onClick={this.viewObjectForm.bind(this)} className="grid-action glyphicon glyphicon-zoom-in"></span> :
      <Link to={APP_PATH + "/" + this.props.parentGrid.props.path + "/" + this.props.object[keyField] + "/view"}>
        <span className="grid-action glyphicon glyphicon-zoom-in" />
      </Link>;

    let modal = null;
    if(this.props.parentModal) {
      modal =
        <Modal show={this.state.showModal} onHide={this.closeObjectForm.bind(this)} bsSize="large">
          <Modal.Header closeButton>
            <Modal.Title>Ajouter à la liste</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.form}
          </Modal.Body>
        </Modal>;
    }


    if (this.props.onlyDelete && this.props.onlyDelete === true) {
      //if(this.state.mode !== "readonly") {
        return (
          <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_DELETE}>
            <div className="grid-action-container">
              {deleteButton}
            </div>
          </PermissionCheck>
        );
      //} else {
      //  return null;
      //}

    } else if(this.props.withoutDelete && this.props.withoutDelete === true) {
      //if(this.state.mode !== "readonly") {
        return (
          <div className="grid-action-container">
            {modal}
            <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_READ}>
              {viewButton}
            </PermissionCheck>
            <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_UPDATE}>
              {editButton}
            </PermissionCheck>
          </div>
    		);
      // } else {
      //   return (
      //     <div className="grid-action-container">
      //       {modal}
      //       <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_READ}>
      //         {viewButton}
      //       </PermissionCheck>
      //     </div>
      //   );
      // }
    } else if(this.props.withoutView && this.props.withoutView === true) {
      //if(this.state.mode !== "readonly") {
        return (
          <div className="grid-action-container">
            {modal}
            <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_UPDATE}>
              {editButton}
            </PermissionCheck>
            <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_DELETE}>
              {deleteButton}
            </PermissionCheck>
          </div>
    		);
      // } else {
      //   return null;
      // }
    } else {
      //if(this.state.mode !== "readonly") {
        return (
          <div className="grid-action-container">
            {modal}
            <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_READ}>
              {viewButton}
            </PermissionCheck>
            <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_UPDATE}>
              {editButton}
            </PermissionCheck>
            <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_DELETE}>
              {deleteButton}
            </PermissionCheck>
          </div>
    		);
      // } else {
      //   return (
      //     <div className="grid-action-container">
      //       {modal}
      //       <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_READ}>
      //         {viewButton}
      //       </PermissionCheck>
      //     </div>
      //   );
      //}
    }
	}

  /**
  * editObjectForm
  * Open the object's form (edit)
  **/
  editObjectForm() {
    this.openObjectForm(true);
  }

  /**
  * viewObjectForm
  * Open the object's form (view)
  **/
  viewObjectForm() {
    this.openObjectForm(false);
  }

  /**
  * openObjectForm
  * Open the object's form
  **/
  openObjectForm(isEdit) {
    const component = React.createElement(this.props.objectClass, {
        mode: isEdit ? "edit" : "readonly",
        objectPath: `${this.props.parentGrid.props.path}/${this.props.object[this.props.parentGrid.getRowKey()]}`,
        data: {
          object: this.props.object
        },
        modal: true,
        closeModal: this.closeObjectForm.bind(this),
        onEdit: this.refreshControlledGrid.bind(this),
    });

    this.setState({
      showModal: true,
      form: component
    });
  }

  /**
  * refreshControlledGrid
  * Reload the parent ControlledGrid
  **/
  refreshControlledGrid(newObj) {
    const parentGrid = this.props.parentGrid;
    const keyField = parentGrid.getRowKey();
    let objects = parentGrid.state.objects.map(obj => {
      if(obj[keyField] === newObj[keyField]) return newObj;
      return obj;
    });

    parentGrid.setState({
      ...parentGrid.state,
      objects: objects
    });

    parentGrid.refs["advancedCbx" + this.props.objectClass.getClassName()].refresh();
  }

  /**
  * closeObjectForm
  * Close the object's form
  **/
  closeObjectForm() {
    this.setState({
      showModal: false,
      form: ""
    });
  }

  /**
  * deleteObject
  * Delegate the deletion of the row to its parent grid
  **/
  deleteObject() {
    this.props.parentGrid.deleteRow(this.props.object);
  }

  /**
  * openGeomModal
  * Open Geom Modal
  **/
  openGeomModal() {
    this.refs.geomModal.setState({
      object: this.props.object,
      opened: true
    });
  }

}

export default Action;



// WEBPACK FOOTER //
// ./src/views/Helper/Grid/Action.js